
















































import { listFactory } from '@/main/pages';
import { Partner } from '@/modules/kartoteka/partner';
import { VozidloPujcovna } from '@/modules/pujcovna/vozidloPujcovna';
import { Zakazka } from '@/modules/servis/zakazka';
import { Pracovnik } from '@/modules/administrace/pracovnik';

import { listMutations } from './store/types';
import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	components: {
		PartnerSelect: Partner.components.Select,
		VozidloPujcovnaSelect: VozidloPujcovna.components.Select,
		ZakazkaSelect: Zakazka.components.Select,
		PracovnikSelect: Pracovnik.components.Select,
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				zakaznik: `${this.storeUri}/${listMutations.ZAPUJCKA_ZAKAZNIK_FILTER_SELECT_MAPPER}`,
				vozidlo: `${this.storeUri}/${listMutations.ZAPUJCKA_VOZIDLO_FILTER_SELECT_MAPPER}`,
				zakazka: `${this.storeUri}/${listMutations.ZAPUJCKA_ZAKAZKA_FILTER_SELECT_MAPPER}`,
				vstupPrac: `${this.storeUri}/${listMutations.ZAPUJCKA_VSTUP_PRAC_FILTER_SELECT_MAPPER}`,
			};
		},
	},
	methods: {
		clearVozidlo() {
			if (!this.VlastnivozPrp && !this.ExternivozPrp) {
				this.VozidlopaSpz = null;
				this.VozidlopaKaroserieNr = null;
				this.VozidlopaId = null;
			}
		},
	},
});
